import { render, staticRenderFns } from "./ShiftListWrapper.vue?vue&type=template&id=54e4013b&"
import script from "./ShiftListWrapper.vue?vue&type=script&lang=js&"
export * from "./ShiftListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ShiftListWrapper.vue?vue&type=style&index=0&id=54e4013b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports